module.exports = __webpack_public_path__ + "static/img/RI.c2d7407.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/states/RI.jpg
// module id = 1gy9
// module chunks = 0